// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1Buow","footer":"ModalUpdate_footer__1uf3L"};